import React from 'react'
import { CustomCard } from 'src/components'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { getFormatedPrice } from 'src/core/helpers'
import StaticsText from './StaticsText/StaticsText'
import { adminStaticsSelector, selectCurrencyToken } from 'src/features'

const UserAdminStatistics: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const { t } = useTranslation()

  const {
    transactionsCount,
    transactionsValue,
    usersPendinToBeValidated,
    userEmail
  } = useAppSelector(adminStaticsSelector)
  const currency = useAppSelector(selectCurrencyToken)

  const textsArray = [
    { label: t('admin.UserEmail'), text: userEmail },
    { label: t('admin.UsersPendingValidation'), text: usersPendinToBeValidated },
    { label: t('admin.TransactionsCount'), text: transactionsCount },
    { label: t('admin.TransactionsValue'), text: getFormatedPrice(transactionsValue, currency) },
  ]

  return <CustomCard cardTitle={t('admin.ClimatetradeInfo')} loading={isLoading}>
    {textsArray.map((item, idx) => <StaticsText
      label={item.label} text={`${item.text}`} key={idx}
    />)}
  </CustomCard>
}

export default UserAdminStatistics
